/**
 * Accordéons Wouska : bascule aria-expanded sur les boutons .wp-acc__btn.
 * Un seul écouteur délégué (robuste aux re-rendus du thème). Le CSS gère l'animation.
 */
if (!window.__wouskaAccordion) {
  window.__wouskaAccordion = true;
  document.addEventListener('click', (event) => {
    const btn = event.target instanceof Element ? event.target.closest('.wp-acc__btn') : null;
    if (!btn) return;
    btn.setAttribute('aria-expanded', String(btn.getAttribute('aria-expanded') !== 'true'));
  });
}
